import { EditorContent, useEditor } from '@tiptap/react'
import './TiptapEditor.css';
import TiptapToolbar from "./TiptapToolbar";
import TiptapExtensions from "./TiptapExtensions";
import TiptapFooter from "./TiptapFooter";
import React, { useEffect } from "react";


const limit = 65535



const TipTapEditor = (props) => {

  let content = props.value;
  const stickyHeader = props.stickyHeader;

  const editor = useEditor({
    extensions: TiptapExtensions,
    content: content,
    onUpdate: ({ editor }) => {
      props.onChange?.(editor.getHTML())
    }
  });

  useEffect(() => {
    if (editor?.isEmpty && content !== '<p></p>') {
      editor.commands.setContent(content);
    }
  }, [content, editor]);

  if (!editor) {
    return null
  }

  return (
    <div className={stickyHeader ? "tiptapEditorLayout hasStickyHeader" : "tiptapEditorLayout"}>
      <div className={stickyHeader ? "tiptapStickyTop" : "tiptapStickyTop withoutStickyHeader"}>
        {stickyHeader ? <div className="tiptapStickyHeader">{stickyHeader}</div> : null}
        <div className="tiptapStickyToolbar">
          <TiptapToolbar editor={editor} />
        </div>
      </div>
      <div className="tiptapEditorContent">
        <EditorContent editor={editor} />
      </div>

      <TiptapFooter editor={editor} limit={limit}/>
    </div>
  )
}

export default TipTapEditor